import { ServiceFetch } from '../service-fetch'

export default class DebitNoteReceiptListModel extends ServiceFetch {
    getDebitNoteReceiptListBy = (data) => this.authFetch({
        url: 'debit-note-receipt-list/getDebitNoteReceiptListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}